import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { deleBindLogins } from "@/api/loginConfig/deleBindLogin";
import { bindThreeList } from "@/api/loginConfig/bindThree";
import bindThree from "./components/addBindThree";
import { login } from "@/api/user";
export default {
  name: "bindThreeLogin",
  components: {
    bindThree: bindThree
  },
  data: function data() {
    return {
      dialog: false,
      typeValue: "",
      searchgames: [],
      tableData: [],
      page: 1,
      total: 0,
      pagSize: 10,
      num: "",
      form: {},
      id: "",
      bindObj: {},
      showing: false,
      addTypeConfig: false
    };
  },
  created: function created() {
    this.getType();
  },
  methods: {
    getType: function getType() {
      var _this = this;

      bindThreeList({
        page: this.page
      }).then(function (res) {
        if (res.status == 200) {
          var list = ['game', 'platform', 'channel', 'pkg'];
          _this.tableData = res.data.data.length ? _this.$utils.dataConversion(res.data.data, list) : [];
          _this.total = res.data.total;
        }
      });
    },
    addType: function addType() {
      this.dialog = true;
      this.num = "1";
    },
    editType: function editType(item) {
      this.dialog = true;
      this.num = "2";
      this.bindObj = item;
    },
    deleType: function deleType(id) {
      var _this2 = this;

      this.$confirm("此操作将删除该类型, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                deleBindLogins({
                  id: id
                }).then(function (res) {
                  _this2.getType();
                });

                _this2.$message({
                  type: "success",
                  message: "删除成功!"
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    },
    handleSource: function handleSource(id) {
      this.$refs.addTypeConfig.init(id);
    },
    changeShow: function changeShow(val) {
      this.showing = val;
      this.getType();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getType();
    },
    changeData: function changeData(val) {
      this.bindObj = val;
    }
  }
};